import { Component, OnInit } from '@angular/core';
import {
	AbstractControl,
	FormControl,
	FormGroup,
	ValidationErrors,
	ValidatorFn,
	Validators
} from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PARAM_LABEL_INTERVENANT } from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { Address } from 'src/app/shared/models/address';
import { ServiceCenter } from 'src/app/shared/models/service-center';
import { Employee } from 'src/app/shared/models/employee/employee';

import { User } from 'src/app/shared/models/security/user';
import { EmployeeType } from 'src/app/shared/models/employee/employee-type';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';

@Component({
	selector: 'app-employee-modal-ajout',
	templateUrl: './employee-modal-ajout.component.html',
	styleUrls: ['./employee-modal-ajout.component.scss']
})
export class EmployeeModalAjoutComponent implements OnInit {
	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked: { value: boolean } = { value: false };
	isAddressDefault: { value: boolean } = { value: true };
	isAddressSelected: { value: boolean } = { value: false };
	isWorkplaceAddressDefault: { value: boolean } = { value: true };
	isWorkplaceAddressSelected: { value: boolean } = { value: false };

	LABEL_INTERVENANT: string;

	MAX_NAME_CHAR = 25;
	NAME_PATTERN = new RegExp("^[0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+$");
	PHONE_NUMBER_PATTERN = '0{1}[0-9]{9}';

	formAjout: FormGroup = new FormGroup(
		{
			firstName: new FormControl('', [
				Validators.required,
				Validators.maxLength(this.MAX_NAME_CHAR),
				Validators.pattern(this.NAME_PATTERN)
			]),
			lastName: new FormControl('', [
				Validators.required,
				Validators.maxLength(this.MAX_NAME_CHAR),
				Validators.pattern(this.NAME_PATTERN)
			]),
			birthDate: new FormControl(''),
			address: new FormControl(new Address().label, Validators.required),
			workplaceAddress: new FormControl(
				new Address().label,
				Validators.required
			),
			phone: new FormControl('', Validators.pattern(this.PHONE_NUMBER_PATTERN)),
			competence: new FormControl(''),
			autoAssignment: new FormControl(false),
			workingHoursPerWeek: new FormControl(35, [
				Validators.required,
				Validators.min(1),
				Validators.max(60)
			]),
			employeeType: new FormControl(EmployeeType.EMP, [Validators.required]),
			email: new FormControl('', [Validators.email]),
			area: new FormControl('Non spécifié')
		},
		{ validators: emailRequiredOnEmployeeType }
	);

	center: ServiceCenter;
	user: User;
	employee = new Employee();

	constructor(
		private router: Router,
		private logger: LogService,
		private facade: FacadeService,
		public bsModalRef: BsModalRef
	) {}

	ngOnInit(): void {
		this.LABEL_INTERVENANT = this.facade.dataStorageService.getLabelCapitalized(
			PARAM_LABEL_INTERVENANT
		);
		this.user = this.facade.dataStorageService.getUser();
		if (this.user) {
			this.center = this.user.employee.serviceCenter;
		}
	}

	onSubmit() {
		this.isValidateButtonClicked.value = true;
		this.employee.serviceCenter = this.center;
		this.facade.employeeService.addEmployee(this.employee).subscribe({
			complete: () => {
				this.isValidateButtonClicked.value = false;
				this.bsModalRef.hide();
			},
			error: (err: ErrorResponse) => {
				this.isValidateButtonClicked.value = false;
				this.facade.toastService.createHttpErrorToast(
					err.error.response,
					err.status
				);
			}
		});
	}
}

export const emailRequiredOnEmployeeType: ValidatorFn = (
	control: AbstractControl
): ValidationErrors | null => {
	const employeeType = control.get('employeeType').value;
	const email = control.get('email').value;

	return employeeType === 'EMP' && (!email || email === '')
		? { emailRequired: true }
		: null;
};
